import React from 'react';
import { TopStrip } from './components/layout/TopStrip';
import { Hero } from './components/sections/Hero';
import { Testimonials } from './components/sections/Testimonials';
import { PainPoints } from './components/sections/PainPoints';
import { TargetAudience } from './components/sections/TargetAudience';
import { SystemIntro } from './components/sections/SystemIntro';
import { TomosGrid } from './components/sections/TomosGrid';
import { BonusGrid } from './components/sections/BonusGrid';
import { ComparisonTable } from './components/sections/ComparisonTable';
import { OfferBlock } from './components/sections/OfferBlock';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/layout/Footer';
import { StickyMobileCTA } from './components/layout/StickyMobileCTA';
import { PurchasePopup } from './components/ui/PurchasePopup';
import { MetaPixel } from './components/analytics/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-dark w-full overflow-x-hidden" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <TopStrip data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Testimonials data-id="element-5" />
        <PainPoints data-id="element-6" />
        <TargetAudience data-id="element-7" />
        <SystemIntro data-id="element-8" />
        <TomosGrid data-id="element-9" />
        <BonusGrid data-id="element-10" />
        <ComparisonTable data-id="element-11" />
        <OfferBlock data-id="element-12" />
        <FAQ data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>

      <Footer data-id="element-15" />
      <StickyMobileCTA data-id="element-16" />
      <PurchasePopup data-id="element-17" />
    </div>;
}